// IE 2026 10 04 / ODOO-5800 (fe-71): ПОКАЗАННЫЙ ТЕКСТ ЯЧЕЙКИ ИЗ ПОЛЯ СТРОКИ `<binding>-title`.
// Бэк может отдать у строки грида поле `<binding>-title` — текст, который ячейка колонки <binding> показывает ВМЕСТО названия записи ссылки / сырого
// значения (грид вкладки Metrics, _doc.metrics_stats: колонки Signal — `metric-title`, Reason — `reason-title`; раньше — `Бренд-title` и т.п.), и подсказку
// ячейки `_DLRow.cells[<binding>].tooltip` (прежнее значение: «Metric: …» / «Reason: …»).
// Здесь — чистая логика без Vue, одна на все пути грида (AttrGrid): отрисовка (полный путь и кэш-путь formatItem), подсказка, быстрый поиск (отбор строк,
// «есть ли строки», фраза, счётчик ‹ ›) и сортировка. Строки без `<binding>-title` эти функции не затрагивают (пустая строка / пустой список / undefined).
// Выключатель fe.grid.shownTitle (дефолт ВКЛ) — в AttrGrid.shownTitle_on. Юнит — tests/unit/shownTitle.test.mjs

import { sigRow_refTitle } from './signalModel.js'   // IE 2026 10 04 / ODOO-5800 (fe-78)

// показанный текст ячейки: значение поля `<binding>-title` строки; '' — поля нет / пусто / не текст и не число
export function shownTitle_of(dataItem, binding) {
    if (!dataItem || typeof dataItem !== 'object' || binding === undefined || binding === null || binding === '') return ''
    const v = dataItem[`${binding}-title`]
    if (typeof v === 'string') return v
    if (typeof v === 'number' && Number.isFinite(v)) return String(v)
    // IE 2026 10 04 / ODOO-5800 (fe-78; модель сигналов v2): поля-подмены `metric-title` / `reason-title` бэк больше не отдаёт — колонки Signal / Cause ссылочные;
    // у строки новой модели показанный текст — название записи от бэка (metric_title / reason_title). Прежний бэк / выключатель fe.signals.modelV2 — ''
    return sigRow_refTitle(dataItem, binding)
}

// текст, который ячейка показывает: `<binding>-title`, иначе base (название записи ссылки / сырое значение — как было)
export function shownTitle_text(dataItem, binding, base) {
    return shownTitle_of(dataItem, binding) || (base === undefined || base === null ? '' : String(base))
}

// тексты ячейки для поиска, в нижнем регистре: показанный текст И прежний (base) — поиск по показанному находит строку, поиск по сырому значению
// продолжает работать; без `<binding>-title` — один прежний текст; пустые и повторы выпадают
export function shownTitle_searchTexts(dataItem, binding, base) {
    const out = []
    const b = base === undefined || base === null ? '' : String(base).toLowerCase()
    if (b) out.push(b)
    const s = shownTitle_of(dataItem, binding).toLowerCase()
    if (s && s !== b) out.push(s)
    return out
}

// ключ сортировки колонки: показанный текст строки; undefined — у строки его нет (сортировка по прежним правилам)
export function shownTitle_sortValue(dataItem, binding) {
    const s = shownTitle_of(dataItem, binding)
    return s ? s : undefined
}

// подсказка ячейки от бэка (`_DLRow.cells[<binding>].tooltip`) — только у ячейки с показанным текстом (он заменил значение, подсказка — единственное место,
// где прежнее значение видно); '' — подсказки нет
export function shownTitle_tip(dataItem, binding) {
    if (!shownTitle_of(dataItem, binding)) return ''
    const c = dataItem._DLRow && dataItem._DLRow.cells ? dataItem._DLRow.cells[binding] : null
    const tip = c && c.tooltip
    return (typeof tip === 'string' && tip.trim()) ? tip : ''
}

// IE 2026 10 04 / ODOO-5800 (fe-72): ПОКАЗ подсказки ячейки с показанным текстом по наведению — всегда, без Alt / Show tooltips.
// Общий затвор App.vue (Tooltip.prototype.show: статичные подсказки только по Alt или опции) гасил её; для элемента с отметкой __shownTip затвор зовёт эту функцию:
// показ откладывается на delayMs покоя в ЭТОЙ ячейке (повторные mousemove в той же ячейке таймер не перезапускают, переход в другую — перезапускает),
// перед показом — проверки: элемент на месте, отметка не снята (wijmo переиспользует элементы), курсор всё ещё над ним, canShow() (Alt не зажат и т.п.).
// На время своего show() элемент несёт __shownTipPass — затвор его пропускает. Возврат: true — таймер заведён, false — уже идёт для этого элемента
export const SHOWN_TIP_DELAY_MS = 1500
let _shownTipTimer = null, _shownTipEl = null
export function shownTip_defer(inst, el, canShow, delayMs = SHOWN_TIP_DELAY_MS) {
    if (!inst || !el) return false
    if (_shownTipTimer && _shownTipEl === el) return false
    if (_shownTipTimer) clearTimeout(_shownTipTimer)
    _shownTipEl = el
    _shownTipTimer = setTimeout(() => {
        _shownTipTimer = null; _shownTipEl = null
        if (!el.isConnected || !el.__shownTip || !el.matches(':hover')) return
        if (typeof canShow === 'function' && !canShow()) return
        const content = inst.getTooltip(el)
        if (!content) return
        el.__shownTipPass = true
        try { inst.show(el, content) } finally { el.__shownTipPass = false }
    }, delayMs)
    return true
}

// IE 2026 10 16 / ODOO-5800: выключатель fe.ux.shownTipHover (дефолт ВЫКЛ) — показ подсказки ячейки с показанным текстом ПО НАВЕДЕНИЮ без Alt (прежнее поведение fe-72).
// Выкл — подсказка показывается как все статичные: по Alt или при Show tooltips (текст подсказки и подстановка `-title` остаются, fe.grid.shownTitle не затронут)
export function shownTip_hoverOn(store) {
    try { return store?.setting?.('fe.ux.shownTipHover', false) === true } catch (e) { return false }
}
